<template>
    <div>
        <transition name="fade">
            <div :key="'resource_dark'" class="pu_dark" v-show="$store.getters.modal.datefilter"></div>
        </transition>
        <transition name="slide">
            <div :key="'resource'" class="pu_bottom popup_click_hide" v-show="$store.getters.modal.datefilter">
                <div class="pu_bottom_scroll">
                    <div @click="close()" class="pu_b_close"></div>
                    <div class="pu_bottom_inner scroll_y"
                         :class="{'full-height': this.$store.getters.container === this.$store.getters.const.CONTAINER_IFRAME}">
                        <v-date-picker is-inline mode='range' v-model='range' :min-date="new Date()" :input-debounce='0'
                                       @drag="dragValue = $event"  style="width: 100%; border: none; margin-top: 30px;"></v-date-picker>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
  import { SET_FILTER, SET_MODAL } from '@/store/mutations.type'

  export default {
    name: 'DateFilter',
    components: {
      'v-date-picker': import(/* webpackPrefetch: true */ 'v-calendar/lib/components/date-picker.umd')
    },
    data() {
      return {
        dragValue: null,
        range: { start: null, end: null },
      }
    },
    computed: {},
    methods: {
      close() {
        this.$store.commit(SET_MODAL, { modal: 'datefilter', status: false })
      },
    },
    watch: {
      range: {
        deep: true,
        handler: function (range) {
          if (!range || range.start === null || range.end === null) {
            if (this.$store.getters.filter.date.start !== null && this.$store.getters.filter.date.end !== null) {
              this.$store.commit(SET_FILTER, {filter: 'date', data: {start: null, end: null}})
            }
          } else {
            this.$store.commit(SET_FILTER, {filter: 'date', data: {start: range.start, end: range.end}})
          }
        }
      },
      dragValue: {
        deep: true,
        handler: function (dragValue) {
          if (dragValue !== null) {
            this.range = { start: null, end: null }
          }
        }
      },
    }
  }
</script>

<style scoped>

</style>

<style>
    .mx-datepicker-popup {
        z-index: 9999999;
    }
</style>
